import React, { useCallback, useMemo, useState } from 'react'
import { Button, Layout, PageHeader } from 'antd'
import HeaderNavigation from '../../components/HeaderNavigation'
import { useDispatch, useSelector } from 'react-redux'
import { userSelector } from '../../store/session'

import './style.css'
import EmployeesTable from '../../components/employee/EmployeesTable'
import EmployeeModal from '../../components/employee/EmployeeModal'
import { getEmployeesAction } from '../../store/employeе'

const { Content } = Layout

const Employees = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(userSelector)

  const [showEmployeeDetail, setShowEmployeeDetail] = useState(false)

  const isProject = useMemo(() => user?.role?.type === 'project_manager', [user])

  const loadEmployees = useCallback(() => dispatch(getEmployeesAction({})), [dispatch])

  const onEmployeeDialogClose = useCallback(() => setShowEmployeeDetail(false), [])

  const onEmployeeDialogSuccess = useCallback(() => {
    onEmployeeDialogClose()
    loadEmployees()
  }, [])

  return (
    <Layout>
      <HeaderNavigation activeKey="6" />
      <Content className="site-layout" style={{ padding: '85px 50px', minHeight: '100vh' }}>
        <PageHeader
          ghost={false}
          title="Пользователи"
          extra={[
            <Button key="1" type="primary" onClick={() => setShowEmployeeDetail(true)}>
              Создать нового пользователя
            </Button>,
          ]}
        />
        {isProject && <EmployeesTable />}
      </Content>
      <EmployeeModal
        showModal={showEmployeeDetail}
        onClose={onEmployeeDialogClose}
        onSuccess={onEmployeeDialogSuccess}
      />
    </Layout>
  )
}

export default Employees
